// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenericModal {
  width: 400px;
  max-height: 530px;
  margin: 0 auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}
.GenericModal h3 {
  color: var(--color_neutral_900);
  font-size: 24px;
  font-weight: 600;
}
.GenericModal .subtitle {
  margin-top: 4px;
  color: var(--color_neutral_800);
  font-weight: normal;
  font-size: 14px;
}
.GenericModal .modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 16px;
}
.GenericModal-error {
  margin: 20px 0;
}
@media only screen and (max-width: 450px) {
  .GenericModal {
    width: 220px;
  }
  .GenericModal > h4 {
    font-size: 14px;
  }
  .GenericModal button {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GenericModal/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACF;AACE;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,+BAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AADJ;AAIE;EACE,cAAA;AAFJ;AAKE;EAjCF;IAkCI,YAAA;EAFF;EAIE;IACE,eAAA;EAFJ;EAKE;IACE,eAAA;EAHJ;AACF","sourcesContent":[".GenericModal {\n  width: 400px;\n  max-height: 530px;\n  margin: 0 auto;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 32px;\n\n  h3 {\n    color: var(--color_neutral_900);\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  .subtitle {\n    margin-top: 4px;\n    color: var(--color_neutral_800);\n    font-weight: normal;\n    font-size: 14px;\n  }\n\n  .modal-actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    column-gap: 16px;\n  }\n\n  &-error {\n    margin: 20px 0;\n  }\n\n  @media only screen and (max-width: 450px) {\n    width: 220px;\n\n    >h4 {\n      font-size: 14px;\n    }\n\n    button {\n      font-size: 12px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
